import { Col, Row, Spin, Switch } from "antd";
import { useEffect, useRef, useState } from "react";
import { connect, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import "./UtilizationDashboardPage.css";

import { UpdateAppConfig } from "../../../src/services/redux/reducers/app";

import {
  GetStatus,
  GetCustomerCurrentTime,
  GetUtilizationData,
  pad,
  readOperatorList,
} from "../../../src/services/common/cnc_apis";

import { CSSTransition } from "react-transition-group";
import UtilizationDetailPage from "./UtilizationDetailPage/UtilizationDetailPage";
import MachineItemContainer from "./MainPage/MachineItemContainer";

function UtilizationDashboardPage(props) {
  const location = useLocation();
  const appData = useSelector((state) => state.app);
  const authData = useSelector((x) => x.authService);
  const { security_level } = authData;
  const { langIndex } = appData;
  const { screenSize } = props.app;

  const customer_id = props.app.customer_id;
  const group_id = props.app.group_id;

  const customerInfo = props.cncService.customerInfoList[customer_id];
  const machineList = props.cncService.utilizationMachineList[customer_id];

  var isPageLoading = machineList === undefined;

  const [selectedMachine, setSelectedmachine] = useState("");
  const [operatorList, setOperatorList] = useState([]);
  const [viewMode, setViewMode] = useState(0);

  const [tick, setTick] = useState(true);
  const [intervalId, setIntervalID] = useState(null);
  const skipNextTickRef = useRef(false);
  const { group_ids } = authData;

  const intervalTime = 60000;

  const timezone = customerInfo["timezone"];

  let startDate = GetCustomerCurrentTime(timezone);
  startDate =
    pad(startDate.getMonth() + 1) +
    "/" +
    pad(startDate.getDate()) +
    "/" +
    pad(startDate.getFullYear());


  let endDate = GetCustomerCurrentTime(timezone);
  endDate.setDate(endDate.getDate() + 1);
  endDate =
    pad(endDate.getMonth() + 1) +
    "/" +
    pad(endDate.getDate()) +
    "/" +
    pad(endDate.getFullYear());

  useEffect(() => {
    GetStatus(customer_id, props.dispatch);
  }, [customer_id]);

  const onSetAutoScroll = (val) => {
    UpdateAppConfig({ isAutoScroll: val }, props.dispatch);
  };

  const timer = () => {
    setTick((t) => !t);
  };

  const onClickMachine = (machine) => {
    onSetAutoScroll(false);
    setSelectedmachine(machine);
  };

  // Auto-select machine from URL query parameter (for token-based URLs)
  useEffect(() => {
    if (!machineList || machineList.length === 0) return;
    
    const searchParams = new URLSearchParams(location.search);
    const machineIdFromUrl = searchParams.get("machine_id");
    
    if (machineIdFromUrl) {
      const machine = machineList.find((m) => m.machine_id === machineIdFromUrl);
      if (machine && selectedMachine === "") {
        setSelectedmachine(machine);
      }
    }
  }, [location.search, machineList, selectedMachine]);

  useEffect(() => {
    skipNextTickRef.current = true;

    // Don't clear selectedMachine if it's from URL query param (for token-based URLs)
    const searchParams = new URLSearchParams(location.search);
    const machineIdFromUrl = searchParams.get("machine_id");

    if (!machineIdFromUrl) {
      setSelectedmachine("");
    }

    readOperatorList((res) => {
      setOperatorList(res);
      GetUtilizationData(
        customer_id,
        timezone,
        startDate,
        endDate,
        "",
        props.dispatch
      );
      const newIntervalId = setInterval(timer, intervalTime);
      setIntervalID(newIntervalId);
    });

    return () => {
      setIntervalID((currentId) => {
        if (currentId) clearInterval(currentId);
        return null;
      });
    };
  }, [customer_id]);

  useEffect(() => {
    // Skip only the first tick after mount/deps change (callback already fetched); then poll every interval.
    if (skipNextTickRef.current) {
      skipNextTickRef.current = false;
      return;
    }
    GetUtilizationData(
      customer_id,
      timezone,
      startDate,
      endDate,
      "",
      props.dispatch
    );
  }, [tick]);

  return (
    <div>
      {isPageLoading && (
        <div style={{ paddingTop: 100, textAlign: "center" }}>
          <Spin tip="Loading ..." size="large" />
        </div>
      )}
      {!isPageLoading && (
        <div>
          {selectedMachine == "" && (
            <div>
              <div className="list-tile-switch-container">
                <Switch
                  className="list-tile-switch"
                  checked={viewMode == 1 ? true : false}
                  onChange={(e) => setViewMode(e == true ? 1 : 0)}
                />
                <div className="list-tile-switch-title">{"Tile"}</div>
              </div>
              <MachineItemContainer
                machineList={machineList}
                customer_id={customer_id}
                group_id={group_id}
                group_ids={group_ids}
                customerInfo={customerInfo}
                onClickMachine={onClickMachine}
                viewMode={viewMode}
                operatorList={operatorList}
                screenSize={screenSize}
              />
            </div>
          )}

          <CSSTransition
            in={selectedMachine !== ""}
            timeout={1000}
            classNames="pageSliderLeft"
            unmountOnExit={true}
          >
            <UtilizationDetailPage
              customer_id={customer_id}
              customerInfo={customerInfo}
              machineInfo={selectedMachine}
              security_level={security_level}
              onCloseMachine={setSelectedmachine}
              operatorList={operatorList}
              screenSize={screenSize}
              dismissible
            />
          </CSSTransition>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state, props) => ({
  cncService: state.cncService,
  app: state.app,
});

const mapDispatchToProps = (dispatch, props) => ({
  dispatch: dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(UtilizationDashboardPage);
